import { c as _c } from "react/compiler-runtime";
import React from "react";
export const WaveWinnersSmallLoading: React.FC = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="tw-h-6 tw-bg-iron-800 tw-rounded-md tw-w-1/3" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="tw-p-3"><div className="tw-animate-pulse tw-space-y-4">{t0}<div className="tw-space-y-3"><div className="tw-h-24 tw-bg-iron-800 tw-rounded-xl" /><div className="tw-h-24 tw-bg-iron-800 tw-rounded-xl" /></div></div></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};